import styled from "styled-components";
export const FeelingOptionsContainer = styled.div`
  width: 100%;
  h6 {
    font-size: 16px;
    color: ${({ theme }) => theme.text.primary};
    font-weight: 700;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }
`;
export const ModalFooter = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    hr {
      width: 100%;
    }
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
  svg {
    color: ${({ theme }) => theme.primary.purple};
    width: 16px;
    margin: 5px;
    height: 16px;
  }
`;

export const OptionsButton = styled.button`
  border: none;
  padding: 0.2rem 0.6rem;
  margin: 0.2rem;
  border: 1px solid #c30091;
  box-sizing: border-box;
  border-radius: 5px;
  background: ${({ state, theme }) => (state ? theme.primary.purpleMedium : theme.neutral.white)};
  color: ${({ state, theme }) => (state ? theme.neutral.white : theme.primary.purpleMedium)};
  cursor: pointer;
`;

export const Title = styled.h6`
  text-align: center;
  color: ${({ theme }) => theme.primary.purple};
  padding: 0rem 2rem;
`;
export const FeelingQuestion = styled.div`
  display: flex;
  width: 100%;
  padding: 5px;
  align-items: center;
  margin-top: 10px;
  svg {
    width: 52px;
    height: 52px;
    margin-top: 2px;
  }
  .flex-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  label {
    font-size: 14px;
    color: ${({ theme }) => theme.text.primary};
    font-weight: 600;
    .MuiTypography-body1 {
      margin-top:-5px;
    }
  }
  .MuiDivider-vertical {
    height: 10em;
  }
  .left-container {
    width: 30%;
    align-items: center;
    margin-left: 30px;
    svg {
      margin-bottom:0;
    }
    label {
      font-size: 16px;
      ont-weight: 600;
    }
  }
  .right-container {
    width: 70%;
    margin-top: 0em;
    justify-content: flex-start;
    @media only screen and (max-width: 768px) {
      margin-left: 20%;
    }
  }
  .MuiFormGroup-root svg {
    width: 15px;
    height: 15px;
  }
  .MuiRadio-colorSecondary.Mui-checked,
  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.button.primary};
  }
  .MuiFormGroup-root {
    width: 100%;
    flex-direction: initial;
    column-gap: 20px;
  }
  .Mui-checked + .MuiFormControlLabel-label {
    font-weight: 600;
  }
  .right-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
  .right-container::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }
  .right-container::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #b1b1b1;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    margin: 1% 0;
    .MuiDivider-vertical {
      display: none;
    }
  }
  .flex-div left-container {
    color: ${({ theme }) => theme.primary.purple};
  }
  .step-2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 13px;
    width: 100%;
    svg {
      width: 26px;
      height: 26px;
    }
  }
  .MuiFormControlLabel-root {
    width: 50%;
    margin-right: 0px;
  }
  .steps-2 .MuiFormControlLabel-root {
    width: 100%;
  }
  .steps-2 .MuiFormControlLabel-root span {
    padding: 0 !important;
  }
`;

export const NextButton = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: right;
  width: 10%;
  height: 25px;
  margin-right: 2%;
  text-align: end;
  max-width: 102px;
  color: ${({ theme }) => theme.neutral.white};
  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin: 0 5px;
  }
  .next-button-icon {
    height: auto;
    width: auto;
  }
  @media only screen and (max-width: 768px) {
    width: 90px;
  }
`;

export const StepTwoFew = styled.div`
  display: flex;
  width: 30%;
  margin-bottom: 0;
  align-items: center;
  flex-direction: column;

  .show-lbl {
    visbility: visible;
  }

  .hide-lbl {
    visibility: hidden;
  }
`;
